import type {FontSizeOption} from '@FormMakerReact/layout/form-maker-right-panel/controls/font-size-control/font-size-control.types';
import {FormMakerFontSize} from '@FormMakerReact/lib/form-maker-typography';

export const HEADING_SIZES: readonly FontSizeOption[] = [
  {label: 'Aa', value: FormMakerFontSize.PX_18},
  {label: 'Aa', value: FormMakerFontSize.PX_22},
  {label: 'Aa', value: FormMakerFontSize.PX_26},
  {label: 'Aa', value: FormMakerFontSize.PX_32},
];
